import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { workspace_userActions } from "../../../actions";
import { Container } from "react-bootstrap";
import { history } from "../../../helpers";
import { PopupAlert } from "../../../components/PopupAlert";
import { userConstants } from "../../../constants";

const AcceptInvitation = () => {
  const { access_token } = useParams();
  const dispatch = useDispatch();
  const [finished, setFinished] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [workspace, setWorkspace] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(access_token){
      const successFunc = (response) => {
        setWorkspace(response.data.data.workspace);
        setAccepted(true);
      }

      const finalFunc = () => {
        setFinished(true);
      }

      const errorFunc = (error) => {
        setError(error);
      }

      dispatch(workspace_userActions.acceptInvitationByToken(access_token, successFunc, errorFunc, finalFunc))
    }
    return () => {
      
    };
  }, []);

  const goToHome = () => {
    history.push('/')
  }

  const goToWorkspace = () => { 
    if (workspace) {
      history.push(`/organizations/${workspace.organization_id}/workspaces/${workspace.id}/list`);
    } else {
      history.push('/');
    }
  }
  
  return (
    <Container>
      {finished && (
        accepted ? (
          <PopupAlert
            show={true}
            handleSubmit={goToWorkspace}
            handleClose={goToWorkspace}
            display_text={userConstants.ACCEPT_INVITATION}
          />
        ) : (
          <PopupAlert
            show={true}
            handleSubmit={goToHome}
            handleClose={goToHome}
            display_text={error ? error : userConstants.ACCEPT_INVITATION_FAILURE}
          />
        )
      )}
    </Container>
  );
};

export default AcceptInvitation;